
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TextButton } from "../Components/Button.js";
import Delete_1 from "../../public/assets/icons/Delete_1.svg";

export function FloatingDialog(props) {
    let elems_3;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "h-20", "rounded-lg", "drop-shadow-2xl", "bg-white"])], (elems_3 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["h-100", "w-2.5", "rounded-l-lg", "bg-primary"]),
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems = [reactElement("div", {
            className: join(" ", ["flex", "items-center", "ml-12", "text-[#808080]"]),
            children: props.Text,
        }), reactElement("div", {
            className: join(" ", ["flex", "items-center", "ml-1", "font-bold", "text-[#808080]"]),
            children: props.Date,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["grow", "mr-11"]),
        })), delay(() => {
            let elems_2, elems_1;
            const matchValue = props.OnCancelClick;
            if (matchValue == null) {
                return empty();
            }
            else {
                const onCancelClick = matchValue;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-3"])], (elems_2 = [createElement(TextButton, {
                    ComponentState: "enabled",
                    Icon: reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_1 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
                    Label: "",
                    OnClick: onCancelClick,
                    TestId: "cancel-button",
                    Variant: "default",
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

